document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('.js-tab-list-form');

  forms.forEach(form => {
    const radios = form.querySelectorAll('.js-tab-radio');

    radios.forEach(radio => {
      radio.addEventListener('change', function() {
        const parentBlock = this.closest('.p-tab-list__block');
        if (parentBlock) {
          parentBlock.querySelectorAll('.p-tab-list__item').forEach(item =>
            item.classList.remove('is-active')
          );

          if (this.value !== '') {
            this.closest('.p-tab-list__item').classList.add('is-active');
          }
        }

        form.submit();
      });
    });
  });
});